
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { BiPaiGoldGameResultData } from "./bipai_gameresult_interface";
import Utility from "../../../../utility/utility";
import BiPaiGoldOneGameResultDetail from "./bipai_onegameresult_detail";
import GameUtil from "../../../../utility/game_util";
import LanguageManager from "../../../../manager/language_manager";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu('custom/bipai/BiPaiGoldOneGameResultView')
export default class BiPaiGoldOneGameResultView extends ViewBase {

    @property(cc.Node)
    nodeWin: cc.Node = null

    @property(cc.Animation)
    nodeWinCloseAnim: cc.Animation = null

    @property(cc.Node)
    nodeLose: cc.Node = null

    @property(cc.Animation)
    nodeLoseCloseAnim: cc.Animation = null

    @property(cc.Label)
    labelWinScore: cc.Label = null

    @property(cc.Label)
    labelLoseScore: cc.Label = null

    @property(cc.Node)
    nodeWinInfoParent: cc.Node = null

    @property(cc.Node)
    nodeLoseInfoParent: cc.Node = null

    @property(cc.Node)
    nodeBtsRoot: cc.Node = null

    @property(BiPaiGoldOneGameResultDetail)
    winDetail: BiPaiGoldOneGameResultDetail = null

    @property(BiPaiGoldOneGameResultDetail)
    loseDetail: BiPaiGoldOneGameResultDetail = null

    @property(cc.Label)
    labelLeftSecs: cc.Label = null


    protected m_schedule_id: number = null
    protected m_intentData: BiPaiGoldGameResultData

    showView(intentData: BiPaiGoldGameResultData) {
        let self = this
        self.unscheduleAllCallbacks()
        this.m_intentData = intentData
        this.showInfoPanel(intentData)
        this.nodeWinCloseAnim.stop()
        this.nodeWinCloseAnim.play('anim_Bipai_jiesuanNormal')   
        this.nodeLoseCloseAnim.stop()     
        this.nodeLoseCloseAnim.play('anim_Bipai_jiesuanNormal')
        this.nodeWin.active = intentData.isWin
        this.nodeLose.active = !intentData.isWin        
    }

    playCloseAnim(onFinish){
        // onFinish && onFinish()
        // return
        if(this.m_intentData.isWin){        
            this.nodeWinCloseAnim.stop()    
            this.nodeWinCloseAnim.play('anim_Bipai_jiesuanClose')
        }else{
            this.nodeLoseCloseAnim.stop()
            this.nodeLoseCloseAnim.play('anim_Bipai_jiesuanClose')
        }
        this.doScheduleOnce(()=>{
            onFinish && onFinish()
        }, 0.5)
    }

    showInfoPanel(intentData: BiPaiGoldGameResultData){
        this.labelWinScore.node.active = intentData.score >= 0
        this.labelLoseScore.node.active = intentData.score < 0
        if(intentData.score >= 0){
            this.labelWinScore.string = '+' + GameUtil.currencyFormatting(intentData.score)                      
        }else{
            this.labelLoseScore.string = GameUtil.currencyFormatting(intentData.score)            
        }
        if(intentData.isWin){
            this.nodeBtsRoot.parent = this.nodeWinInfoParent
            this.nodeBtsRoot.position = cc.Vec2.ZERO  
        }else{
            this.nodeBtsRoot.parent = this.nodeLoseInfoParent
            this.nodeBtsRoot.position = cc.Vec2.ZERO
        }
        this.winDetail.showDetail(intentData.isWin, intentData)
        this.loseDetail.showDetail(!intentData.isWin, intentData)
        this.refreshLeftSecs(5)
    }

    protected refreshLeftSecs(leftSecs: number){
        let self = this
        if(self.m_schedule_id){
            self.cancelSchedule(self.m_schedule_id)
            self.m_schedule_id = null
        }
        this.labelLeftSecs.string = leftSecs.toString()
        self.m_schedule_id = self.doScheduleOnce(function(){
            self.m_schedule_id = null
            leftSecs--
            leftSecs = Math.max(leftSecs, 0)
            if(leftSecs == 0){
                self.m_intentData['_click_continue_btn'] && self.m_intentData['_click_continue_btn']()
            }else{
                self.refreshLeftSecs(leftSecs)
            }
        }, 1)
    }

    protected registUiBtnClick() {
        
    }

    protected unregistUiBtnClick() {
        
    }




}
